import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, MessageCircleQuestion, ArrowRight } from "lucide-react";
import { ROUTES, FAQS } from "../site";
import { usePageMeta } from "../hooks/usePageMeta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";
import WavyDivider from "../components/WavyDivider";

const meta = ROUTES[4];

export default function Faq() {
  usePageMeta(meta.title, meta.description);
  const [openId, setOpenId] = useState(FAQS[0].id);

  return (
    <div data-testid="faq-page">
      <Header />
      <main>
        <Breadcrumbs current="FAQ" />
        <section className="container-site pb-12 pt-8 sm:pb-16">
          <span className="eyebrow-chip">
            <MessageCircleQuestion className="h-3.5 w-3.5 text-bun-dark" aria-hidden="true" />
            Tanya Jawab
          </span>
          <h1 className="mt-4 max-w-3xl text-balance font-display text-4xl font-extrabold leading-tight tracking-tight text-plum sm:text-5xl">
            Pertanyaan yang Sering Ditanyakan
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-plum-soft sm:text-lg">
            Semua yang perlu kamu tahu tentang Yupi Burger — dari status halal, varian, sampai
            tempat membelinya.
          </p>
        </section>

        <section aria-label="Daftar pertanyaan" className="container-site pb-14 sm:pb-20">
          <div className="mx-auto max-w-3xl space-y-4">
            {FAQS.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className="overflow-hidden rounded-3xl border-2 border-plum/10 bg-white shadow-sm"
                >
                  <h2>
                    <button
                      type="button"
                      data-testid={faq.testid}
                      aria-expanded={isOpen}
                      aria-controls={`faq-panel-${faq.id}`}
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                      className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-display text-base font-bold text-plum transition-colors hover:bg-bun-soft sm:text-lg"
                    >
                      {faq.q}
                      <ChevronDown
                        aria-hidden="true"
                        className={`h-5 w-5 shrink-0 text-bun-dark transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                      />
                    </button>
                  </h2>
                  <div
                    id={`faq-panel-${faq.id}`}
                    role="region"
                    className={isOpen ? "block" : "hidden"}
                  >
                    <p className="px-6 pb-6 text-sm leading-relaxed text-plum-soft sm:text-base">
                      {faq.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <section aria-label="Masih penasaran" className="bg-berry-soft">
          <WavyDivider fill="#FFFDF9" flip />
          <div className="container-site py-14 text-center sm:py-16">
            <h2 className="font-display text-2xl font-bold tracking-tight text-plum sm:text-3xl">
              Masih Penasaran?
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum-soft sm:text-base">
              Kenali dulu semua variannya, atau langsung cari tahu di mana kamu bisa membelinya.
            </p>
            <div className="mt-7 flex flex-wrap justify-center gap-3">
              <Link to="/produk/" data-testid="faq-cta-products" className="btn-primary">
                Lihat Produk
                <ArrowRight className="h-5 w-5" aria-hidden="true" />
              </Link>
              <Link to="/beli/" data-testid="faq-cta-where-to-buy" className="btn-secondary">
                Dimana Beli
              </Link>
            </div>
          </div>
          <WavyDivider fill="#FFFDF9" />
        </section>
      </main>
      <Footer />
    </div>
  );
}
